// extracted by mini-css-extract-plugin
export default {"header":"ForgotPassword_header__31gPk"};